import DeclaracionJuradaConfig from "./DeclaracionJuradaConfig";

export default class DeclaracionJuradaService {
	static setDeclaracionJurada(value, id) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = DeclaracionJuradaConfig.endpointSetDeclaracionJuradas;
				let response = await DeclaracionJuradaConfig.APIConnector.post(
					endpoint,
					{
						body
					}
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateDeclaracionJurada(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = DeclaracionJuradaConfig.endpointGetDeclaracionJuradas;
				let response = await DeclaracionJuradaConfig.APIConnector.put(
					endpoint,
					{
						body
					}
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteDeclaracionJurada(declaracionJuradaId, declaracionJurada) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(declaracionJurada);
				let endpoint =
					DeclaracionJuradaConfig.endpointDeleteDeclaracionJuradas +
					"/" +
					declaracionJuradaId;
				let response = DeclaracionJuradaConfig.APIConnector.delete(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static getDeclaracionJuradaList(searchText, month, year, page, size, status) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointGetDeclaracionJuradas + "?";
				if (searchText) endpoint += "&searchText=" + searchText;
				if (month) endpoint += "&month=" + month;
				if (year) endpoint += "&year=" + year;
				if (page && size) endpoint += "&page=" + page + "&size=" + size;
				if (status) endpoint += "&status=" + status;
				let response = await DeclaracionJuradaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static procesarExcel(excel, mes, anio) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointProcesarExcel +
					"?mes=" +
					mes +
					"&anio=" +
					anio;
				let response = await DeclaracionJuradaConfig.APIConnector.post(
					endpoint,
					{
						body: excel,
						multiPartFlag: true
					}
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static createDJ(idTempDJ, isNewDJ, month, year) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointCreateDJ +
					"?month=" +
					month +
					"&year=" +
					year +
					"&idTempDJ=" +
					idTempDJ +
					"&isNewDJ=" +
					isNewDJ;
				let response = await DeclaracionJuradaConfig.APIConnector.post(
					endpoint
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static checkPeriodo(month, year) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointCheckPeriodo +
					"?mes=" +
					month +
					"&anio=" +
					year;
				let response = await DeclaracionJuradaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static checkPeriodoFixedContribution(month, year) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointCheckPeriodoFixedContribution +
					"?mes=" +
					month +
					"&anio=" +
					year;
				let response = await DeclaracionJuradaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getDJDetail(idDJ, page, size) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = DeclaracionJuradaConfig.endpointDJDetail + "?";
				if (idDJ) {
					endpoint += "&idDJ=" + idDJ;
				}
				if (page && size) {
					endpoint += "&page=" + page + "&size=" + size;
				}
				let response = await DeclaracionJuradaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static printDJ(idDJ) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					DeclaracionJuradaConfig.endpointPrintDJ + "?idDJ=" + idDJ;
				let response = await DeclaracionJuradaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/DeclaracionJurada/DeclaracionJuradaService.js